import React from 'react';
import { Tooltip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { usePriceService } from '../../../../utils/hooks/priceService';
import { TopTable } from '../../../../server-types';
import { FancyCard } from '../style';
import { CardTitle, Typography } from '../../../../ui-kit';

const TopTableCardView: React.FC<TopTable> = ({ name, orderQuantity, totalPriceSold }) => {
    const { priceService } = usePriceService();
    const { t } = useTranslation();
    return (
        <>
            <FancyCard />
            <Tooltip title={name} aria-label={name} placement='top'>
                <CardTitle gutterBottom noWrap>{name}</CardTitle>
            </Tooltip>
            <Typography gutterBottom variant="body2">
                {t('Income: {{incomeAmount}}', { incomeAmount: priceService.toLocaleString(totalPriceSold) })}
            </Typography>
            <Typography variant="body2">{t('Orders served: {{orderQuantity}}', { orderQuantity })}</Typography>
        </>
    );
};

export default TopTableCardView;
